const {createPrimaryBeneficiary} = require("./constants");
const {NassauLog} = require("./myga-utils");
const {v4: uuidv4} = require("uuid");
let logo_url = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMDAgMzAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzAwNUI5OTt9Cjwvc3R5bGU+Cjx0aXRsZT5saWdodGhvdXNlPC90aXRsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0OC40LDIyNy44Yy0wLjUsMC42LTAuOCwxLTEuMSwxLjRjLTAuMywwLjMtMC41LDAuOC0wLjgsMS4xbC0wLjEsMC4xbC0xOC44LTEwLjlMMjAyLjksMjM5bC0zLjktNS42bC0xMy40LDUKCUwxNzIsMjIyLjFjLTAuOC0xNy41LTEuMy00MC40LTEuOS02MC44Yy0wLjYtMTguMy0xLjMtMzUuNi0xLjYtNDYuNWgyLjZjMS4zLDAsMi43LTAuMiw0LjItMC4yaDFsLTAuMi0xYy0wLjMtMy44LTAuNi04LTAuOC0xMgoJdi0wLjhoLTcuNHYtMy4yaDMuNHYtMWMwLTEuMy0wLjEtMi40LTAuMS0zLjV2LTAuOGgtMy40bC0wLjMtNS41YzAtNS4xLTAuMS0xMC40LTAuMy0xNS45aDIuMmwtMC4xLTEuMWMtMS44LTguMS04LjItMTQuNC0xNi40LTE2CglWNDMuM2gtNy4ydjEwLjRjLTguMiwxLjYtMTQuNyw3LjgtMTYuNSwxNmwtMC4yLDEuMWgyLjNjLTAuMiw3LjItMC40LDE0LjMtMC42LDIxLjNIMTI3djUuM2gzLjVjLTAuMSwwLjctMC4yLDEuNC0wLjEsMi4xbC0wLjIsMS4xCglIMTIzbC0wLjMsNS45Yy0wLjIsMi40LTAuMyw0LjctMC41LDYuOWwtMC4xLDFoMWMxLjYsMCwyLjksMC4yLDQuMiwwLjJoMi42Yy0wLjQsMTEuNC0xLDI5LjUtMS42LDQ4LjZjLTAuMywxMS4xLTAuNiwyMi44LTEuMSwzNC4zCglsLTIuNy0zLjRMNjkuNCwyMzZsLTcuMS02LjdsLTcuOSw0LjJjLTAuNS0wLjUtMS4xLTEuMS0xLjYtMS44Yy0xLjgtMi4xLTMuMS0zLjgtNC4zLTUuNUM2LjQsMTcwLjcsMTcuMiw5MS41LDcyLjcsNDkuNAoJYzIyLTE2LjcsNDguOC0yNS43LDc2LjQtMjUuN2M2OS41LDAsMTI2LjEsNTYuNiwxMjYuMSwxMjYuM2MwLDI1LjktNy45LDUxLjEtMjIuNiw3Mi40QzI1MS40LDIyNC4xLDI0OS45LDIyNi4xLDI0OC40LDIyNy44CglMMjQ4LjQsMjI3LjhMMjQ4LjQsMjI3Ljh6IE0xNTUuNCw3MC4xaDcuN2MwLjEsNy43LDAuMywxNS4yLDAuMywyMi45Yy0yLjYsMC01LjEsMC03LjUsMC4yQzE1NS42LDg1LjMsMTU1LjQsNzcuOCwxNTUuNCw3MC4xCglMMTU1LjQsNzAuMUwxNTUuNCw3MC4xeiBNMTQ1LjYsOTMuMmMwLjItNy45LDAuMi0xNS40LDAuMy0yMy4xaDYuNnYyMy4xTDE0NS42LDkzLjJMMTQ1LjYsOTMuMnogTTEzNC43LDkzCgljMC40LTcuNywwLjUtMTUuMiwwLjUtMjIuOWg3LjVjMCw3LjctMC4xLDE1LjItMC4xLDIzLjFDMTQwLDkzLDEzNy40LDkzLDEzNC43LDkzTDEzNC43LDkzeiBNMTM1LjUsMTEzLjloNi42CgljLTAuMSwyMS0wLjYsNjYuNC0xLjEsMTAxLjJsLTcuOS05LjFDMTM0LDE3Mi4zLDEzNC44LDEzMywxMzUuNSwxMTMuOUwxMzUuNSwxMTMuOUwxMzUuNSwxMTMuOXogTTE0OS4xLDI3Ni4yCgljLTI2LjgsMC4xLTUyLjktOC40LTc0LjUtMjQuM2w0MS45LTM5LjJ2OC43bDYuNywwLjVMMTExLjYsMjQwbDE1LjQtNi4ybDEzLjgtNC4zbDAuOC0wLjJ2LTAuMmwxNC42LTQuNWwxMC4xLDEyLjJsLTkuOSwxOC42CglsMzcuMS05LjRsNS4zLDEwbDI5LjQtMjIuOGwxMC4xLDYuM2MtMjMuNSwyMy44LTU1LjYsMzcuMS04OSwzNi45bDAsMEwxNDkuMSwyNzYuMnogTTE0OS4xLDEzLjljLTc1LjEsMC0xMzYuMSw2MC45LTEzNi4xLDEzNgoJUzczLjksMjg2LDE0OS4xLDI4NmM3NS4xLDAsMTM2LjEtNjAuOSwxMzYuMS0xMzZDMjg1LjIsNzQuOSwyMjQuNCwxNCwxNDkuMSwxMy45QzE0OS4yLDEzLjksMTQ5LjIsMTMuOSwxNDkuMSwxMy45TDE0OS4xLDEzLjkKCUwxNDkuMSwxMy45eiIvPgo8L3N2Zz4K';
exports.appLogo = logo_url;

// SA20220511.ADivelbiss - added a switch to enable/disable FL flow in one location.
exports.ENABLE_FLORIDA_FLOW = true;

// 20220525.ADivelbiss - added to switch FIA Flow
exports.ENABLE_FIA_FLOW = false;

// app pages
const PAGES = {
  pageLanding   : 'pageLanding',
  pageDashboard  : 'pageDashboard',
  pageResearchCenter : 'pageResearchCenter',
  pageAppProcessOverview  : 'pageAppProcessOverview',
  pageAppSubmitApp  : 'pageAppSubmitApp',
  pageAppPayments  : 'pageAppPayments',
  pageAppIdVerify  : 'pageAppIdVerify',
  pageAppIdDataEntry  : 'pageAppIdDataEntry',
  pageAppIdFinish  : 'pageAppIdFinish',
  pageAppGoals  : 'pageAppGoals',
  pageAppGoalsFL  : 'pageAppGoalsFL',   // Florida App Goals Page 2022.03.14.Michael
  pageAppFinances  : 'pageAppFinances',
  pageAppFinalize  : 'pageAppFinalize',
  pageAppPremium  : 'pageAppPremium',
  pageAppBenes  : 'pageAppBenes',
  pageAppCompleted  : 'pageAppCompleted',  // PathA Final Landing Page
  pageAppPartialComplete  : 'pageAppPartialComplete', // PathB Final Landing Page
  pageAppPartialCompleteAR : 'pageAppPartialCompleteAR', // PathC Final Landing Page.  Partially completed but with agent recommendation
  pageAppIdScan : 'pageAppIdScan',
  pageAppMailCheckInfo : 'pageAppMailCheckInfo',
  pageAppConfirmEFT : 'pageAppConfirmEFT',

  pageGuestEmail  : 'pageGuestEmail',
  pageAgentCode  : 'pageAgentCode',
  pageScheduleCall  : 'pageScheduleCall',
  
  // 20210406.ADivelbiss - New Product Pages
  pageAppProductStore : 'pageAppProductStore',
  pageAppProductCart : 'pageAppProductCart',
  
  // 20210803.ADivelbiss - Knockout Pages
  pageAppKnockout : 'pageAppKnockout',
  pageAppKnockoutLanding : 'pageAppKnockoutLanding',

  // 2021.06.30.ADivelbiss - New Owner/Annuitant Pages
  pageAppIdConfig  : 'pageAppIdConfig',
  pageAppIdOwnerAnnuitant  : 'pageAppIdOwnerAnnuitant',
  pageAppIdOwnerJoint  : 'pageAppIdOwnerJoint',
  pageAppIdAnnuitant  : 'pageAppIdAnnuitant',
  pageAppIdAnnuitantJoint  : 'pageAppIdAnnuitantJoint',
  pageAppIdOwnerAnnuitantSummary: 'pageAppIdOwnerAnnuitantSummary',


  // 20210713.ADivelbiss - FL Pages
  pageAppFinancesFL : 'pageAppFinancesFL',
  pageAppNeedsFL : 'pageAppNeedsFL',
  pageAppFundsFL : 'pageAppFundsFL',
  pageAppGeneralFL : 'pageAppGeneralFL',
  pageAppSubmitAppClientFL: 'pageAppSubmitAppClientFL',
  pageAppSubmitAppAgentFL: 'pageAppSubmitAppAgentFL',
  
  dashboardFullPages: {
    pageRateCharts : 'pageRateCharts',
    pageTreasuryBillRateList: 'pageTreasuryBillRateList',
    pageTreasuryNoteRateList: 'pageTreasuryNoteRateList',
    pageBankCDRateList: 'pageBankCDRateList',
    pageMoneyMarketRateList: 'pageMoneyMarketRateList'
  },


    // test pages
    pageProducts  : 'pageProducts',
    pageOwner     : 'pageOwner',
    pageBenes     : 'pageBenes',
    pagePayment   : 'pagePayment',
    pageTest      : 'pageTest'

};
exports.PAGES = PAGES;

// app page titles
const _PAGE_TITLES = {
  pageLanding   : 'Simple Annuity',
  pageDashboard  : 'Simple Annuity Dashboard',
  pageResearchCenter : 'Research Center',
  pageAppProcessOverview  : 'Application Process Overview',
  pageAppSubmitApp  : 'Submit Application',
  pageAppPayments  : 'Payment Information',
  pageAppIdVerify  : 'Verify Your Identity',
  pageAppIdDataEntry  : 'Enter Your Identity Information',
  pageAppIdFinish  : 'Final Identity Information',
  pageAppGoals  : 'Your Goals',
  pageAppGoalsFL  : 'Your Goals',
  pageAppFinances  : 'Your Finances',
  pageAppFinalize  : 'Final Check',
  pageAppPremium  : 'Select a Product',
  pageAppBenes  : 'Beneficiaries',
  pageAppCompleted  : 'Application Completed',
  pageAppPartialComplete  : 'Schedule a Call',
  pageAppIdScan : 'Scan Your Identity Information',
  pageAppMailCheckInfo : 'Check Payment Confirmation',
  pageAppConfirmEFT : 'EFT Payment Confirmation',
  
  pageGuestEmail  : 'Guest Email',
  pageAgentCode  : 'Agent Referral Code',
  pageScheduleCall  : 'Schedule a Call',
  
  // 20210406.ADivelbiss - New Product Pages
  pageAppProductStore : 'Product Store',
  pageAppProductCart : 'Product Cart',
  
  dashboardFullPages: {
    pageRateCharts : 'Rate Charts',
    pageTreasuryBillRateList: 'Treasury Bill Rates',
    pageTreasuryNoteRateList: 'Treasury Note Rates',
    pageBankCDRateList: 'Bank CD Rates',
    pageMoneyMarketRateList: 'Money Market Rates'
  }
  
};
exports.PAGE_TITLES = _PAGE_TITLES;

// state
const STATE = {
  page: 'page',
  ownerPageState: 'ownerPageState'
};
exports.STATE = STATE;

let initialState = () => {
  return {
    showTimeoutWarning: false,
    page: PAGES.pageLanding,
    agentReferralCode: null
  }
};
exports.initialState = initialState;

const isValid = (obj) => {
  return (obj !== null && obj !== undefined);
};

const isString = (obj) => {
  return (typeof obj === 'string' || obj instanceof String);
};

let createObjectForKeys = (keys, defaultValue = '') => {
  return Object.values(keys).reduce((prev, key)=>{
    let obj = {};
    obj[key] = (isString(defaultValue) || !isValid(defaultValue)) ? defaultValue : isValid(defaultValue[key]) ? defaultValue[key] : '';
    return Object.assign(prev, obj);
  },{});
};
exports.createObjectForKeys = createObjectForKeys;

let duplicateObject = (object) => {
  return JSON.parse(JSON.stringify(object));
};
exports.duplicateObject = duplicateObject;

const _PRODUCT_ID = Object.freeze({
  simpleAnnuity : "simpleannuity2",
  myAnnuity: "myAnnuity"
});
exports.PRODUCT_ID = _PRODUCT_ID;

const LEAD_TYPE = Object.freeze({
  mygaLead : "PNX MYGA Lead"
});
exports.LEAD_TYPE = LEAD_TYPE;

const CHANNEL_TYPE = Object.freeze({
  direct : "Direct",
  mobilewebsite : "Mobile website"
});
exports.CHANNEL_TYPE = CHANNEL_TYPE;

const _PRINCIPAL = Object.freeze({
  email : "email",
  userName : "userName",
  name : "name",
  given_name : "given_name",
  family_name : "family_name",
  relationship : "relationship",
  masterProducerId : "masterProducerId",
  clientProfileIds : "clientProfileIds",
  sessionId : "sessionId",
  pToken : "pToken",
  gs : "gs",
  userType : "userType"
});
exports.PRINCIPAL = _PRINCIPAL;

const _AGENT_INFO = Object.freeze({
  referralCode : "referralCode",
  masterProducerId : "masterProducerId",
  name : "name",
  phone : "phone",
  email : "email",
  producerCodes : "producerCodes",
  recommendationCode: "recommendationCode"
});
exports.AGENT_INFO = _AGENT_INFO;

const _RECOMMENDATION_CODE = Object.freeze({
  none: "-1", // less than 0 is a referral not a recommendation.
  default: "0"
});
exports.RECOMMENDATION_CODE = _RECOMMENDATION_CODE;


// New AgentInfo format for D4A.
const _AGENT_INFO_V01 = Object.freeze({
  firstName : "firstName",
  lastName : "lastName",
  email : "email",
  mobile : "mobile",
  producerCode : "producerCode",
  referralCode : "referralCode",
  recommendationCode: "recommendationCode",
  hasSecuritiesLicense: "hasSecuritiesLicense",
  firmName: "firmName",
  firmPhone: "firmPhone"
});
exports.AGENT_INFO_V01 = _AGENT_INFO_V01;

const _DEPOSIT = Object.freeze({
  deposit6yr : "year6Deposit",
  rate6yr : "year6Rate",
  deposit4yr : "year4Deposit",
  rate4yr : "year4Rate"
});
/**
 * @deprecated
 * @type {Readonly<{deposit6yr: string, rate4yr: string, rate6yr: string, deposit4yr: string}>}
 */
exports.DEPOSIT = _DEPOSIT;

const _FINANCES = Object.freeze({
  incomeYear : "incomeYear",
  expensesMonthly : "expensesMonthly",
  netWorth : "netWorth",
  liquidAssets : "liquidAssets",
  otherContracts : "otherContracts",
  incomeAnalysis : "incomeAnalysis",
  selectedIncome : "selectedIncome",
  selectedExpenses : "selectedExpenses",
  
  // 2021.09.02.ADivelbiss - added to support new exact amounts and annualized expenses
  incomeAnnual : "incomeAnnual",
  incomeApplicantAnnual : "incomeApplicantAnnual",
  expensesAnnual : "expensesAnnual",
  
  // 2021.09.07.ADivelibiss - used for liquid asset validation only.
  ageGTE65: "ageGTE65",
  
  // Additional suitability
  sourceOfFundsStocks: "SOF_STOCK",
  sourceOfFundsCD: "SOF_CD",
  sourceOfFundsFA: "SOF_FA",
  sourceOfFundsVA: "SOF_VA",
  sourceOfFundsIA: "SOF_IA",
  sourceOfFunds401K: "SOF_401K",
  sourceOfFundsPSP: "SOF_PSP",
  sourceOfFundsCS: "SOF_CS",
  sourceOfFundsLI: "SOF_LI",
  sourceOfFundsPP: "SOF_PP",
  sourceOfFundsDP: "SOF_DP",
  sourceOfFundsMM: "SOF_MM",
  sourceOfFundsTSP: "SOF_TSP", // thrift savings plan
  
  // Non-qualified OR IRA QUESTIONS
  sourceOfFundsNewPurchase: "SOF_NEW_PURCHASE",
  sourceOfFunds1035: "SOF_1035",
  sourceOfFundsTradIRA: "SOF_TRADITIONAL_IRA",
  sourceOfFundsRothIRA: "SOF_ROTH_IRA",
  sourceOfFundsSepIRA: "SOF_SEP_IRA",
  sourceOfFundsSepIRAName: "SOF_SEP_IRA_NAME",
  sourceOfFundsSepIRATaxID: "SOF_SEP_IRA_TaxID",
  sourceOfFundsSimpleIRA: "SOF_SIMPLE_IRA",
  sourceOfFundsSimpleIRAName: "SOF_SIMPLE_IRA_NAME",
  sourceOfFundsSimpleIRATaxID: "SOF_SIMPLE_IRA_TaxID",
  
  // Additional Questions FL
  sourceOfIncomeWages : "SOI_WAGES",
  sourceOfIncomePension : "SOI_PENSION",
  sourceOfIncomeSS : "SOI_SS",
  sourceOfIncomeInvestment : "SOI_II",
  sourceOfIncomeRMD : "SOI_RMD",
  sourceOfIncome72TQ : "SOI_72TQ",
  sourceOfIncomeDisability : "SOI_DISABILITY",
  sourceOfIncomeDisabilityYears : "SOI_DISABILITY_EXP",
  sourceOfIncomeOther : "SOI_OTHER",
  sourceOfIncomeOtherExp : "SOI_OTHER_EXP",
  
  annuityOwnership: "ANNUITY_OWNERSHIP",
  annuityOwnershipExp: "ANNUITY_OWNERSHIP_EXP",
  lifeOwnership: "LIFE_OWNERSHIP",
  lifeOwnershipExp: "LIFE_OWNERSHIP_EXP",
  incomeCoversExpenses: "INCOME_COVERS_EXPENSES",
  livingExpensesChange: "LIVING_EXP_CHG",
  livingExpensesChangeExp: "LIVING_EXP_CHG_EXP",
  medicalExpensesChange: "MED_EXP_CHG",
  medicalExpensesChangeExp: "MED_EXP_CHG_EXP",
  incomeCoversExpensesInSurrenderPeriod: "INCOME_COVERS_EXPENSES_IN_SUR_PER",
  incomeCoversExpensesInSurrenderPeriodExp: "INCOME_COVERS_EXPENSES_IN_SUR_PER_EXP",
  hasEmergencyFund: "HAS_EMERGENCY_FUND",
  
});
exports.FINANCES = _FINANCES;

exports.FINANCES_NET_WORTH_MIN = 150000;
exports.FINANCES_INC_EXP_RATIO_MIN = 0.1;
exports.FINANCES_INCOME_ANNUAL_MIN = 12000;

const _INCOME_ANALYSIS = Object.freeze({
  incomeMax : "incomeMax",
  incomeMin : "incomeMin",
  expensesMax : "expensesMax",
  expensesMin : "expensesMin",
  incomeYearMin : "incomeYearMin",
  expensesMonthMin : "expensesMonthMin",
  incomeYearMax : "incomeYearMax",
  expensesMonthMax   : "expensesMonthMax",
  incomeMonth : "incomeMonth",
  expensesYear : "expensesYear"
});
exports.INCOME_ANALYSIS = _INCOME_ANALYSIS;

exports.createDefaultFinances = () => {
  let finances = createObjectForKeys(_FINANCES,'');
  finances[_FINANCES.incomeAnalysis] = createObjectForKeys(_INCOME_ANALYSIS,'');
  return finances;
};

const _NEEDS = Object.freeze({
  purchaseReason: "PURCHASE_REASON",
  objectivePreservation: "INVEST_OBJ_PRESERVATION",
  objectiveDeathBenefit: "INVEST_OBJ_DB",
  objectiveOptions: "INVEST_OBJ_ANNUITY_OPTS",
  objectiveTaxDeferral: "INVEST_OBJ_TAX_DEF",
  objectiveMinGRate: "INVEST_OBJ_MIN_G_RATE",
  objectivePotentialGrowth: "INVEST_OBJ_POTENTIAL_GROWTH",
  objectiveSafetyAndGrowth: "INVEST_OBJ_SAFETY_PRINCIPAL_GROWTH",
  objectiveAllocToIndexed: "INVEST_OBJ_ALLOC_TO_INDEXED",
  objectiveMedicalExpense: "INVEST_OBJ_MEDICAL_EXPENSE",
  objectiveIncome: "INVEST_OBJ_INCOME",
  objectivePassAssets: "INVEST_OBJ_PASS_ASSETS",
  objectiveSafetyAndIncome: "INVEST_OBJ_SAFETY_PRINCIPAL_INCOME",
  objectiveOther: "INVEST_OBJ_OTHER",
  objectiveOtherExp: "INVEST_OBJ_OTHER_EXP",
  riskToleranceConservative: 'RISK_TOLERANCE_CONSERVATIVE',
  riskToleranceModConservative: 'RISK_TOLERANCE_MOD_CONSERVATIVE',
  riskToleranceModerate: 'RISK_TOLERANCE_MODERATE',
  riskToleranceModAggressive: 'RISK_TOLERANCE_MOD_AGGRESSIVE',
  riskToleranceAggressive: 'RISK_TOLERANCE_AGGRESSIVE',
  riskToleranceOther: 'RISK_TOLERANCE_OTHER',
  riskToleranceOtherText: 'RISK_TOLERANCE_OTHER_TEXT',
  riskToleranceComments: 'RISK_TOLERANCE_COMMENTS',
  fedIncomeTaxBracket10: 'FED_INCOME_TAX_BRACKET_10',
  fedIncomeTaxBracket12: 'FED_INCOME_TAX_BRACKET_12',
  fedIncomeTaxBracket22: 'FED_INCOME_TAX_BRACKET_22',
  fedIncomeTaxBracket24: 'FED_INCOME_TAX_BRACKET_24',
  fedIncomeTaxBracket32: 'FED_INCOME_TAX_BRACKET_32',
  fedIncomeTaxBracket35: 'FED_INCOME_TAX_BRACKET_35',
  fedIncomeTaxBracket37: 'FED_INCOME_TAX_BRACKET_37',
  investmentExperience: 'INVESTMENT_EXPERIENCE',
  incomeRiderWaitYears: 'INCOME_RIDER_WAIT_YEARS',
  withdrawalImpact: 'WITHDRAWAL_IMPACT',
  discussCareProtectionBenefit: 'DISCUSS_CARE_PROTECTION_BENEFIT',
  explainStrategyFee: 'EXPLAIN_STRATEGY_FEE'
});
exports.NEEDS = _NEEDS;

const _FUNDS = Object.freeze({
  penaltyFreeAccess: 'penaltyFreeAccess',
  expectLumpSumPayments: 'expectLumpSumPayments',
  expectLumpSumPaymentsExp: 'expectLumpSumPaymentsExp',
  replacement: 'replacement',
  replacementHasPenalty: 'replacementHasPenalty',
  replacementCharge: 'replacementCharge',
  hasReverseMortgage: 'hasReverseMortgage',
  usingProceedsFromReverseMortgage: 'usingProceedsFromReverseMortgage',
  additionalInfo: 'additionalInfo'
})
exports.FUNDS = _FUNDS

const _GENERAL = Object.freeze({
  assistedLiving: 'assistedLiving',
  terminalIllness: 'terminalIllness',
  memoryDisease: 'memoryDisease',
  saleArrangement: 'saleArrangement',
  trustEstablishment: 'trustEstablishment',
  trustEstablishmentFLExp: 'trustEstablishmentFLExp'
})
exports.GENERAL = _GENERAL

const _GOALS = Object.freeze({
  answerUsingQualifiedFunds : "usingQualifiedFunds",
  answerNeedEarlyAccessToMoney : "needEarlyAccess",
  answerHaveAdequateSavings : "haveAdequateSavings",
  answerIsReplacement : "isReplacement",
  answerStopPaymentOnOtherPolicies : "stopPaymentOnOtherPolicies",
  answerApplicantImpaired: "applicantIsImpaired",
  answerUsingReverseMortgage: "usingReverseMortgage",
  answerSourceOfFundsPenalty: "answerSourceOfFundsPenalty",
});
exports.GOALS = _GOALS;

const _ENTITY_TYPE = Object.freeze({
  individual : "Individual",
  trust : "Trust"
});
exports.ENTITY_TYPE = _ENTITY_TYPE;


const _ID_VERIFY = Object.freeze({
  entryType : "entryType",
  citizenship : "residenceStatus"
});
/**
 * @deprecated
 * @type {Readonly<{entryType: string, citizenship: string}>}
 */
exports.ID_VERIFY = _ID_VERIFY;

const _ID_DATA_ENTRY = Object.freeze({
  firstName : "firstName",
  lastName : "lastName",
  addressStreet : "addressStreet",
  addressCity : "addressCity",
  addressZip : "addressZip",
  idNumber : "idNumber",
  idType : "idType",
  addressState : "addressState",
  addressCountry : "addressCountry",
  issuingState : "issuingState",
  dob : "dob",
  idExpiration : "idExpiration",
  gender : "gender"
});
/**
 * @deprecated
 * @type {Readonly<{addressCountry: string, lastName: string, addressZip: string, idType: string, gender: string, addressState: string, issuingState: string, idNumber: string, firstName: string, idExpiration: string, addressStreet: string, dob: string, addressCity: string}>}
 */
exports.ID_DATA_ENTRY = _ID_DATA_ENTRY;

// Age calculation function from original DTC MYGA project
// the date format of data[fname] is assumed MM-DD-YYYY
exports.getAgeFromDOB = (section,dobKey) => {
  
  const parts = section[dobKey].split("-");
  
  const dob = new Date(
      parseInt(parts[2], 10),
      parseInt(parts[0], 10) - 1,
      parseInt(parts[1], 10)
  );
  
  const today_date = new Date();
  const today_year = today_date.getFullYear();
  const today_month = today_date.getMonth();
  const today_day = today_date.getDate();
  
  let age = today_year - dob.getFullYear();
  
  if ( today_month < (dob.getMonth() - 1)){
    age--;
  }
  
  if (((dob.getMonth() - 1) === today_month) && (today_day < dob.getMonth())){
    age--;
  }
  
  return age;
}


const _ID_TYPES = Object.freeze({
  DriversLicenseOrID: "DRIVERS_LICENSE_OR_STATE_ID",
  Passport: "PASSPORT"
});
exports.ID_TYPES = _ID_TYPES;

const _ID_FINISH = Object.freeze({
  daytimePhone : "SECTION_2_HOME_TELEPHONE",
  occupation :  "annuitantOccupation",
  occupationOther : "OWNER_OCCUPATION_DESCRIPTION",
  ssnOrTaxId : "govId",
  activeDutyServicePerson : "memberOfMilitary",
  jointOwner: "jointOwner",   // 2021.05.21.ADivelbiss - added issue tracker Item 75.
  jointAnnuitant: "jointAnnuitant" // 2021.05.21.ADivelbiss - added issue tracker Item 75.
});
/**
 * @deprecated
 * @type {Readonly<{occupation: string, activeDutyServicePerson: string, jointOwner: string, occupationOther: string, ssnOrTaxId: string, daytimePhone: string, jointAnnuitant: string}>}
 */
exports.ID_FINISH = _ID_FINISH;

// 2021.06.29.ADivelbiss - At some point we're going to need an Owner object rather than ID_xxxxxx objects
const _ID_CONFIG = Object.freeze({
  citizenship : "residenceStatus",
  owner: "owner",
  jointOwner: "jointOwner",
  annuitant: "annuitant",
  jointAnnuitant: "jointAnnuitant"
})
/**
 * @deprecated
 * @type {Readonly<{owner: string, citizenship: string, jointOwner: string, annuitant: string, jointAnnuitant: string}>}
 */
exports.ID_CONFIG = _ID_CONFIG;


const _OWNER_TYPE = Object.freeze({
  primary: "owner",
  joint: "jointOwner",
  none: "nonOwner",
});
exports.OWNER_TYPE = _OWNER_TYPE;

const _ANNUITANT_TYPE = Object.freeze({
  primary: "annuitant",
  joint: "jointAnnuitant",
  none: "nonAnnuitant",
});
exports.ANNUITANT_TYPE = _ANNUITANT_TYPE;

const _PARTY_TYPE = Object.freeze({
  // most common types
  ownerAnnuitant: 'Owner - Annuitant',
  owner: 'Owner',
  jointOwner: 'Joint Owner',
  annuitant: 'Annuitant',
  jointAnnuitant: 'Joint Annuitant',
  // other types not supported in the forms
  ownerJointAnnuitant: "Owner / Joint Annuitant", // is this possible?
  jointOwnerAnnuitant: "Joint Owner / Annuitant", // is this possible?
  jointOwnerJointAnnuitant: "Joint Owner / Joint Annuitant" // is this possible?
});
exports.PARTY_TYPE = _PARTY_TYPE;

const _PARTY = Object.freeze({
  uid: "uid",
  firstName : "firstName",
  lastName : "lastName",
  addressStreet : "addressStreet",
  addressCity : "addressCity",
  addressZip : "addressZip",
  addressState : "addressState",
  addressCountry : "addressCountry",
  idNumber : "idNumber",
  idType : "idType",
  idExpiration : "idExpiration",
  issuingState : "issuingState",
  dob : "dob",
  age : "age",
  gender : "gender",
  citizenship : "residenceStatus",
  daytimePhone : "SECTION_2_HOME_TELEPHONE",
  occupation :  "annuitantOccupation",
  occupationOther : "annuitantOccupationOther",
  ssnOrTaxId : "govId",
  activeDutyServicePerson : "memberOfMilitary",
  ownerType: "ownerType",
  annuitantType: "annuitantType",
  entityType: "entityType",
  relationshipToOwner : "relationshipToOwner",
  relationshipToAnnuitant : "relationshipToAnnuitant",
  relationshipToJointOwner : "relationshipToJointOwner",
  relationshipToJointAnnuitant : "relationshipToJointAnnuitant",
  sameAsOwner : "sameAsOwner",
  sameAsAnnuitant : "sameAsAnnuitant",
  sameAsJointOwner : "sameAsJointOwner",
  sameAsJointAnnuitant : "sameAsJointAnnuitant",
  trustName : "trustName",
  dateOfTrust : "dob",
  email: "email",
})
exports.PARTY = _PARTY;

exports.typeForParty = party => {
  if (party[_PARTY.ownerType]===_OWNER_TYPE.primary && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.primary) {
    return _PARTY_TYPE.ownerAnnuitant;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.primary && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.none) {
    return _PARTY_TYPE.owner;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.joint && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.none) {
    return _PARTY_TYPE.jointOwner;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.none && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.primary) {
    return _PARTY_TYPE.annuitant;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.none && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.joint) {
    return _PARTY_TYPE.jointAnnuitant;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.primary && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.joint) {
    return _PARTY_TYPE.ownerJointAnnuitant;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.joint && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.primary) {
    return _PARTY_TYPE.jointOwnerAnnuitant;
  } else if (party[_PARTY.ownerType]===_OWNER_TYPE.joint && party[_PARTY.annuitantType]===_ANNUITANT_TYPE.joint) {
    return _PARTY_TYPE.jointOwnerJointAnnuitant;
  }
  return "";
}

exports.getReciprocalRelationshipFor = (relationship) => {
  switch (relationship) {
    case _PARTY_RELATIONSHIPS.spouse:
      return _PARTY_RELATIONSHIPS.spouse;
    case _PARTY_RELATIONSHIPS.civilUnionPartner:
      return _PARTY_RELATIONSHIPS.civilUnionPartner;
    case _PARTY_RELATIONSHIPS.child:
      return _PARTY_RELATIONSHIPS.parent;
    case _PARTY_RELATIONSHIPS.family:
      return _PARTY_RELATIONSHIPS.family;
    case _PARTY_RELATIONSHIPS.grandchild:
      return _PARTY_RELATIONSHIPS.grandparent;
    case _PARTY_RELATIONSHIPS.grandparent:
      return _PARTY_RELATIONSHIPS.grandchild;
    case _PARTY_RELATIONSHIPS.parent:
      return _PARTY_RELATIONSHIPS.child;
    case _PARTY_RELATIONSHIPS.sibling:
      return _PARTY_RELATIONSHIPS.sibling;
    case _PARTY_RELATIONSHIPS.other:
      return _PARTY_RELATIONSHIPS.other;
    default:
      return relationship;
  }
}

const _PARTY_RELATIONSHIPS_SELECT = Object.freeze({
  spouse: "Spouse",
  civilUnionPartner: "Civil Union Partner",
  child: "Child",
  family: "Family",
  fiancee: "Fiancee",
  grandchild: "Grandchild",
  grandparent: "Grandparent",
  parent: "Parent",
  sibling: "Sibling",
  other: "Other"
});
exports.PARTY_RELATIONSHIPS_SELECT = _PARTY_RELATIONSHIPS_SELECT;

const _PARTY_RELATIONSHIPS = Object.freeze({
  none: "None",
  self: "Self",
  spouse: _PARTY_RELATIONSHIPS_SELECT.spouse,
  civilUnionPartner: _PARTY_RELATIONSHIPS_SELECT.civilUnionPartner,
  child: _PARTY_RELATIONSHIPS_SELECT.child,
  family: _PARTY_RELATIONSHIPS_SELECT.family,
  fiancee: _PARTY_RELATIONSHIPS_SELECT.fiancee,
  grandchild: _PARTY_RELATIONSHIPS_SELECT.grandchild,
  grandparent: _PARTY_RELATIONSHIPS_SELECT.grandparent,
  parent: _PARTY_RELATIONSHIPS_SELECT.parent,
  sibling: _PARTY_RELATIONSHIPS_SELECT.sibling,
  other: _PARTY_RELATIONSHIPS_SELECT.other
});
exports.PARTY_RELATIONSHIPS = _PARTY_RELATIONSHIPS;



const _createOwnerAnnuitant = (
    ownerType=_OWNER_TYPE.primary,
    annuitantType=_ANNUITANT_TYPE.primary,
    entityType = _ENTITY_TYPE.individual
) => {
  let party = createObjectForKeys(_PARTY,"");
  party[_PARTY.ownerType] = ownerType;
  party[_PARTY.annuitantType] = annuitantType;
  party[_PARTY.entityType] = entityType
  // initialize relationship fields
  party[_PARTY.relationshipToOwner] = _PARTY_RELATIONSHIPS.none;
  party[_PARTY.relationshipToAnnuitant] = _PARTY_RELATIONSHIPS.none;
  party[_PARTY.relationshipToJointOwner] = _PARTY_RELATIONSHIPS.none;
  party[_PARTY.relationshipToJointAnnuitant] = _PARTY_RELATIONSHIPS.none;
  return party;
}

exports.createOwnerAnnuitant = () => _createOwnerAnnuitant(_OWNER_TYPE.primary,_ANNUITANT_TYPE.primary);
exports.createOwner = () => _createOwnerAnnuitant(_OWNER_TYPE.primary,_ANNUITANT_TYPE.none);
exports.createAnnuitant = () => _createOwnerAnnuitant(_OWNER_TYPE.none,_ANNUITANT_TYPE.primary);
exports.createJointOwner = () => _createOwnerAnnuitant(_OWNER_TYPE.joint,_ANNUITANT_TYPE.none);
exports.createJointAnnuitant = () => _createOwnerAnnuitant(_OWNER_TYPE.none,_ANNUITANT_TYPE.joint);

const _BENEFICIARY = Object.freeze({
  uid: "uid",
  entityType: "entityType",
  firstName : "firstName",
  lastName : "lastName",
  dob : "dob",
  relationshipToOwner : "relationship",
  beneficiaryType : "status",
  gender : "sex",
  allocation : "share"
});
exports.BENEFICIARY = _BENEFICIARY;

const _BENEFICIARY_TRUST = Object.freeze({
  uid: "uid",
  entityType: "entityType",
  trustName : "trustName",
  dateOfTrust : "dob",
  beneficiaryType : "status",
  allocation : "share",
  taxId: "taxId"
});

const _BENE_RELATIONSHIPS_SELECT = Object.freeze({
  spouse: "Spouse",
  civilUnionPartner: "Civil Union Partner",
  child: "Child",
  family: "Family",
  fiancee: "Fiancee",
  grandchild: "Grandchild",
  grandfather: "Grandfather",
  grandmother: "Grandmother",
  parent: "Parent",
  brother: "Brother",
  sister: "Sister",
  other: "Other"
});
exports.BENE_RELATIONSHIPS_SELECT = _BENE_RELATIONSHIPS_SELECT;

exports.BENEFICIARY_TRUST = _BENEFICIARY_TRUST;
exports.BENEFICIARY_TRUST_FIRST_NAME = "see Section 9";
exports.BENEFICIARY_SURVIVOR_FIRST_NAME = "Surviving";
exports.BENEFICIARY_SURVIVOR_LAST_NAME = "Spouse";
exports.BENEFICIARY_SURVIVOR_UID = "beneficiarySurvivorUID";

const _BENEFICIARY_TYPE = Object.freeze({
  primary : "Primary",
  contingent : "Contingent"
});
exports.BENEFICIARY_TYPE = _BENEFICIARY_TYPE;

const createBeneficiary = (type, entity=_ENTITY_TYPE.individual) => {
  let objectType = _BENEFICIARY;
  if (entity===_ENTITY_TYPE.trust) {
    objectType = _BENEFICIARY_TRUST
  }
  let bene = createObjectForKeys(objectType,"");
  bene[_BENEFICIARY.beneficiaryType] = type;
  bene[_BENEFICIARY.entityType] = entity;
  bene[_BENEFICIARY.allocation] = 0;
  return bene;
};
exports.createBeneficiary = createBeneficiary;
    
exports.createPrimaryBeneficiary = () => {
  return createBeneficiary(_BENEFICIARY_TYPE.primary, _ENTITY_TYPE.individual);
};

exports.createContingentBeneficiary = () => {
  return createBeneficiary(_BENEFICIARY_TYPE.contingent, _ENTITY_TYPE.individual);
};

exports.createPrimaryTrustBeneficiary = () => {
  return createBeneficiary(_BENEFICIARY_TYPE.primary, _ENTITY_TYPE.trust);
};

exports.createContingentTrustBeneficiary = () => {
  return createBeneficiary(_BENEFICIARY_TYPE.contingent, _ENTITY_TYPE.trust);
};

exports.updateBene = (bene) => {

}

exports.createPrimaryBeneficiaryFromParty = (party) => {
  // NassauLog(`This is our Joint Owner (IN THE FUNC): ${JSON.stringify(party,null,2)}`)
  let priBene = createBeneficiary(_BENEFICIARY_TYPE.primary, _ENTITY_TYPE.individual);
  // Transfer Data Over
  if (party[_PARTY.entityType]===_ENTITY_TYPE.individual) {
    priBene[_BENEFICIARY.uid] = party[_PARTY.uid];
    priBene[_BENEFICIARY.firstName] = party[_PARTY.firstName];
    priBene[_BENEFICIARY.lastName] = party[_PARTY.lastName];
    priBene[_BENEFICIARY.dob] = party[_PARTY.dob];
    priBene[_BENEFICIARY.relationshipToOwner] = party[_PARTY.relationshipToOwner];
    priBene[_BENEFICIARY.gender] = party[_PARTY.gender];
  } else {
    priBene[_BENEFICIARY_TRUST.uid] = party[_PARTY.uid];
    priBene[_BENEFICIARY_TRUST.entityType] = party[_PARTY.entityType];
    priBene[_BENEFICIARY.firstName] = exports.BENEFICIARY_TRUST_FIRST_NAME;
    priBene[_BENEFICIARY_TRUST.trustName] = party[_PARTY.trustName];
    priBene[_BENEFICIARY_TRUST.dateOfTrust] = party[_PARTY.dateOfTrust];
    priBene[_BENEFICIARY_TRUST.taxId] = ''; //party[_PARTY.ssnOrTaxId]; 20220505.ADivelbiss - currently we do not collect the taxID here so initialize to empty
  }

  NassauLog(`new Bene Uid: ${priBene[_BENEFICIARY.uid]}`);
  return priBene;
}

exports.nameOfBene = (bene) => {
  if (bene[_BENEFICIARY.entityType] === _ENTITY_TYPE.trust) {
    return bene[_BENEFICIARY_TRUST.trustName];
  }
  return bene[_BENEFICIARY.firstName] + (isValid(bene[_BENEFICIARY.lastName]) ? ` ${bene[_BENEFICIARY.lastName]}` : '');
}


// 2021.02.08.ADivelbiss - Moved bene util functions to this central location
// since they are now needed in multiple places.
exports.validateBene = (bene) => {
  if (bene[_BENEFICIARY.uid]===exports.BENEFICIARY_SURVIVOR_UID) {
    return true
  } else if (bene[_BENEFICIARY.entityType]===_ENTITY_TYPE.trust) {
    if (bene[_BENEFICIARY_TRUST.trustName]==='') return false;
    if (bene[_BENEFICIARY_TRUST.dob]==='') return false;
    if (bene[_BENEFICIARY_TRUST.beneficiaryType]==='') return false;
    if (bene[_BENEFICIARY_TRUST.allocation]===0) return false;
  } else {
    if (bene[_BENEFICIARY.firstName]==='') return false;
    if (bene[_BENEFICIARY.lastName]==='') return false;
    if (bene[_BENEFICIARY.dob]==='') return false;
    if (bene[_BENEFICIARY.relationshipToOwner]==='') return false;
    if (bene[_BENEFICIARY.gender]==='') return false;
    if (bene[_BENEFICIARY.beneficiaryType]==='') return false;
    if (bene[_BENEFICIARY.allocation]===0) return false;
  }
  return true;
};

exports.benesForType = (beneType, benes) => {
  return benes.filter(bene => (bene[_BENEFICIARY.beneficiaryType] === beneType));
};

exports.numberOfBenes = (beneType, benes) => {
  return this.benesForType(beneType,benes).length || 0;
};

exports.totalBenes = (benes) => {
  return benes.length || 0;
};

exports.totalAllocation = (beneType, benes) => {
  let filteredBenes = this.benesForType(beneType,benes);
  let total = filteredBenes.reduce((total,bene)=>{return total+bene[_BENEFICIARY.allocation];},0);
  return Math.round(total);
};
// END 2021.02.08.ADivelbiss

const _PAYMENT = Object.freeze({
  amount : "amount",
  paymentType : "paymentType",
  bankName : "bank_name",
  bankRoutingNumber : "bank_routing",
  bankAccountNumber : "bank_accountNum",
  bankAccountNumberConfirm : "bank_confirmNum",
  bankAccountType : "bank_account_type",
  isManualEntry : "isManualEntry",
  payorUid: "payorUid"
});
/**
 * @deprecated
 * @type {Readonly<{amount: string, isManualEntry: string, bankAccountType: string, bankRoutingNumber: string, bankAccountNumberConfirm: string, bankName: string, bankAccountNumber: string, payorUid: string, paymentType: string}>}
 */
exports.PAYMENT = _PAYMENT;

const _PAYMENT_ADDITIONAL = Object.freeze({
  bankAmount : "bank_Amount",
  checkAmount : "check_Amount",
  paymentType : "",
  bankName : "bank_name",
  bankRoutingNumber : "bank_routing",
  bankAccountNumber : "bank_accountNum",
  bankAccountNumberConfirm : "bank_confirmNum",
  bankAccountType : "bank_account_type",
  isManualEntry : "isManualEntry"
});
/**
 * @deprecated
 * @type {Readonly<{bankAmount: string, isManualEntry: string, bankAccountType: string, checkAmount: string, bankRoutingNumber: string, bankAccountNumberConfirm: string, bankName: string, bankAccountNumber: string, paymentType: string}>}
 */
exports.PAYMENT_ADDITIONAL  = _PAYMENT_ADDITIONAL;

const _PAYMENT_TYPE = Object.freeze({
  bank : "bank",
  check : "check",
  a1035 : "1035",
  rollover : "rollover"
});
/**
 * @deprecated
 * @type {Readonly<{bank: string, rollover: string, check: string, a1035: string}>}
 */
exports.PAYMENT_TYPE  = _PAYMENT_TYPE;

const _PAYMENT_AMOUNT = Object.freeze({
  bank : "bank_Amount",
  check : "check_Amount",
  a1035 : "1035_Amount",
  rollover : "rollover_Amount"
});
/**
 * @deprecated
 * @type {Readonly<{bank: string, rollover: string, check: string, a1035: string}>}
 */
exports.PAYMENT_AMOUNT  = _PAYMENT_AMOUNT;

const _PAYMENT_LIST = Object.freeze({
  payments6yr : "year6",
  payments4yr : "year4"
});
/**
 * @deprecated
 * @type {Readonly<{payments4yr: string, payments6yr: string}>}
 */
exports.PAYMENT_LIST = _PAYMENT_LIST;
/**
 * @deprecated
 * @returns {unknown}
 */
exports.paymentList = () => {
  return createObjectForKeys(_PAYMENT_LIST,[]);
};

const _SOURCE_OF_FUNDS_ATTESTATION = Object.freeze({
  excludesSecurities: "SOF_SEC_NONE",
  includesSecuritiesProducerLicensedYes: "SOF_SEC_YES",
  includesSecuritiesProducerLicensedNo: "SOF_SEC_NO",
});
exports.SOURCE_OF_FUNDS_ATTESTATION = _SOURCE_OF_FUNDS_ATTESTATION;

const _APP_SUBMISSION = Object.freeze( {
  consentSignature : "ELECTRONIC_SIGNATURE_CONSENT",
  consentDisclosure :"ELECTRONIC_DISCLOSURE_CONSENT",
  appCompletionStatus : "APP_COMPLETION_STATUS",
  sourceOfFundsAttestation: "SOURCE_OF_FUNDS_ATTESTATION",

  // Client Florida
  infoRefuse: 'infoRefuse',
  infoLimited: 'infoLimited',
  purchaseIsNotRecommended: 'purchaseIsNotRecommended',
  purchaseIsRecommended: 'purchaseIsRecommended',
  producerAuthorized: 'producerAuthorized',

  // Agent Florida
  proposedAdvantages: 'proposedAdvantages',
  proposedDisadvantages: 'proposedDisadvantages',
  basisOfRecommendation: 'basisOfRecommendation',
  ownerAnnuitantActiveDuty: 'ownerAnnuitantActiveDuty',
  ownerAnnuitantActiveDutyExp: 'ownerAnnuitantActiveDutyExp',
  agentRecommended: 'agentRecommended',
  timeKnowingOwner: 'timeKnowingOwner',
  
  // RMD Question
  hasTakenRMDForCY: 'hasTakenRMDForCY'
  
});
exports.APP_SUBMISSION = _APP_SUBMISSION;

const _APPOINTMENT = Object.freeze({
  date: "date",
  hour: "hour"
});
exports.APPOINTMENT = _APPOINTMENT;

const _APP_STATUS = Object.freeze({
  channelSource : "channelSource",
  page : "page",
  sfRecordTypeId: "sfRecordTypeId"
});
exports.APP_STATUS = _APP_STATUS;

const _APP_DATA = Object.freeze({
  formID: "formID",
  formStatus: "formStatus",
  appData: "appData",
  applicationId: "applicationId",
  startDate: "startDate",
  lastUpdateTime: "lastUpdateTime",
  userId: "userId",
  userEmail: "userEmail",
  appStatus: "appStatus",
  appSubmitStatus: "appSubmitStatus" // local submission status use only.
});
exports.APP_DATA = _APP_DATA;

// MYGA application session keys
const _APPLICATION = Object.freeze({
  rates : "rates",
  deposit : "deposit",
  goals : "goals",
  idVerify : "identity1",
  idDataEntry : "identity2",
  idFinish : "identity3",
  beneficiaries : "benes",
  payments : "payments",
  submission : "submission",
  finances : "finances",
  needs : "needs",
  funds : "funds",
  general : "general",
  referral : "referral",
  appointment: "appointment"
});
exports.APPLICATION = _APPLICATION;

// Added to support the mapping at
// MYGAStorage.swift getSectionDictionary
const _APP_SECTION = Object.freeze({
  rates :  _APPLICATION.deposit,
  /**
   * @deprecated - replaced by products
   */
  deposit : _APPLICATION.deposit,
  goals : _APPLICATION.goals,
  identity1 : _APPLICATION.idVerify,
  identity2 : _APPLICATION.idDataEntry,
  identity3 : _APPLICATION.idFinish,
  benes : _APPLICATION.beneficiaries,
  payments : _APPLICATION.payments,
  submission : _APPLICATION.submission,
  finances : _APPLICATION.finances,
  needs: _APPLICATION.needs,
  funds: _APPLICATION.funds,
  general: _APPLICATION.general,
  referral :_APPLICATION.referral,
  // 2020.04.06.ADivelbiss - Additional sections to support product cart
  productCart : "productCart",
  // 2022.05.10.ADivelbiss - products section to replace deposits to transfer selected products to backend
  products: "products",
  // 2020.06.30.ADivelbiss - Additional sections to support the Joint Owner, Annuitant, and Joint Annuitant
  idConfig: "idConfig",
  owner: "owner",
  jointOwner: "jointOwner",
  annuitant: "annuitant",
  parties: "parties",
  // 2021.10.04.ADivelbiss - Additional section to support scheduled call.
  appointment: _APPLICATION.appointment,
  validation: "validation"
});
exports.APP_SECTION = _APP_SECTION;

// storage keys for data kept in the sessionStorage but not part of the myga application per se
const STORAGE_KEYS  = Object.freeze({
  GuestId : "GuestId",
  WebDataMygaRates : "WebDataMygaRates",
  WebDataBankRates: "WebDataBankRates",
  WebDataTreasuryRates: "WebDataTreasuryRates",
  WebDataProductRates: "WebDataProductRates", // 2022.05.11.ADivelbiss - added to support myannuity rates
  OktaAuthStatus : "OktaAuthStatus",
  TokenValidationRequest : "TokenValidationRequest",
  NsreClient : "NsreClient",
  NsrePrincipalRegistered : "NsrePrincipalRegistered",
  NsrePrincipalGuest : "NsrePrincipalGuest",
  UserProfile : "UserProfile",
  ShoppingCartResponse : "ShoppingCartResponse",
  LastUser : "LastUser",
  IsFirstAppRun : "IsFirstAppRun",
  GuestEmail : "GuestEmail",
  ShowRateChangeMessage : "ShowRateChangeMessage",
  UpdateInfo : "UpdateInfo",
  AgentInfo : "AgentInfo",
  ShowAgentInfoOnLoad : "ShowAgentInfoOnLoad",
  AppMessage : "AppMessage",
  AgentMessageDismissed : "AgentMessageDismissed",
  CurrentApplication: "currentApp", // 2021.01.15.ADivelbiss - added to persist app in local/session storage
  ReturnToPage: "returnToPage", // 2021.01.22.ADivelbiss - added to specify a page to "return to" off the main flow. to be cleared after use
  ShowCancel: 'showCancel', // 2021.08.27.TSchreck - added to support showing Cancel/Next and Ok for returnToPage scenario
  WebDataRateFile : "WebDataRateFile", // 2021.01.28.ADivelbiss - added to support landing footnote date.
  PageStack: "pageStack", // 2021.03.03.ADivelbiss - added to help manage the prev/back button for more complicated mutli-path scenarios
  maxPage: 'maxPage', // 2021.05.17.ADivelbiss added to support maximum page tracking
  CurrPage: 'CurrPage', // 2021.07.15.ADivelbiss added to track current page and also be able to clear it via standard mechanism
  AppZipCode: 'AppZipCode', // 2021.06.24.ADivelbiss - ZipCode for the current application. May affect available questions.
  AppStateAbbr: 'AppStateAbbr', // 2021.06.24.ADivelbiss - State for the current application. May affect available questions.
  AckPrivacyPolicy: 'AckPrivacyPolicy', // 2021.07.14.ADivelbiss - added to track master PP acknowledgement
  AckTermsOfUse: 'AckTermsOfUse', // 2021.07.14.ADivelbiss - added to track master TOU acknowledgement,
  CurrentProductType: 'CurrentProductType',
  CurrentPartyIndex: 'CurrentPartyIndex', // 2021.10.20.ADivelbiss - added to track the index party currently being edited.
  FirstPageOfTest: 'FirstPageOfTest', // 2022.05.10.TSchreck - added to track the first page which to be navigated to when starting a test
  ErrorMessage: 'ErrorMessage', // 2022.07.05.ADivelbiss - added to record the error message for testing purposes
  PrevPageStack: "prevPageStack", // 2022.07.08.ADivelbiss - added to preserve the record of the page stack at the end of the last submission.
});
exports.STORAGE_KEYS = STORAGE_KEYS;

const _OCCUPATIONS_COMMON = Object.freeze([
  "US POSTAL WORKER",
  "ADMINISTRATOR",
  "NURSE",
  "TEACHER",
  "MANAGER",
  "SALES",
  "ENGINEER",
  "CLERK",
  "SELF EMPLOYED",
  "MAINTENANCE",
  "DRIVER",
  "HOMEMAKER",
  "CUSTOMER SERVICE REP",
  "ACCOUNTANT",
  "LABOURER",
  "CONSULTANT",
  "CONSTRUCTION",
  "COMPUTER SERVICE",
  "EXECUTIVE",
  "BANKER",
  "ELECTRICIAN",
  "FARMER",
  "DOCTOR",
  "POLICEMAN",
  "CUSTODIAN",
  "CASHIER",
  "CARPENTER",
  "ATTORNEY",
  "MILITARY",
  "PROFESSOR",
  "PHARMACIST"
]);
exports.OCCUPATIONS_COMMON = _OCCUPATIONS_COMMON;

const _OCCUPATIONS = Object.freeze([
  "ACCOUNTANT",
  "ACTUARY",
  "ADJUSTER",
  "ADMINISTRATOR",
  "ADVERTISER",
  "AGENCY",
  "AGENT",
  "ANALYST",
  "ANESTHESIOLOGIST",
  "ANNOUNCER",
  "APPRENTICE",
  "ARCHITECT",
  "ARRANGER",
  "ARTIST",
  "ASSEMBLER",
  "ASSISTANT",
  "ATTENDANT",
  "ATTORNEY",
  "AUCTIONEER",
  "AUDITOR",
  "BAKER",
  "BANKER",
  "BARBER",
  "BEAUTICIAN",
  "BOOKKEEPER",
  "BRAKEMAN",
  "BRICKLAYER",
  "BROKER",
  "BUILDER",
  "BUSINESS WOMAN",
  "BUSINESSMAN",
  "BUTCHER",
  "CABINET MAKER",
  "CAPTAIN",
  "CARETAKER",
  "CARPENTER",
  "CASHIER",
  "CHEF",
  "CHILD",
  "CHIROPRACTOR",
  "CLEANER",
  "CLERGYMAN",
  "CLERK",
  "COMPUTER SERVICE",
  "CONSTRUCTION",
  "CONSULTANT",
  "CONTRACTOR",
  "CONTROLLER",
  "COOK",
  "COUNSELOR",
  "CUSTODIAN",
  "CUSTOMER SERVICE REP",
  "DENTIST",
  "DESIGNER",
  "DEVELOPER",
  "DIRECTOR",
  "DIRECTOR OF ADMINISTRATION",
  "DISPATCHER",
  "DOCTOR",
  "DRAFTSMAN",
  "DRIVER",
  "ELECTRICIAN",
  "ENGINEER",
  "ESTATE PLANNER",
  "EXAMINER",
  "EXECUTIVE",
  "FARMER",
  "FIREMAN",
  "FISHERMAN",
  "FLIGHT ATTENDANT",
  "FLORIST",
  "FOREMAN",
  "FUNERAL DIRECTOR",
  "GARDENER",
  "GENERAL",
  "GEOLOGIST",
  "GOVERNMENT EMPLOYEE",
  "GRAPHIC ARTIST",
  "GROCER",
  "GUARD",
  "HAIRDRESSER",
  "HANDLER",
  "HOME HEALTH AID",
  "HOMEMAKER",
  "HOSTESS",
  "HOUSEKEEPER",
  "HOUSEWIFE",
  "IMPORTER",
  "INFORMATION MANAGEMENT",
  "INSPECTOR",
  "INSTALLER",
  "INSTRUCTOR",
  "INSURANCE AGENT",
  "INVESTIGATOR",
  "JANITOR",
  "JEWELER",
  "LABOURER",
  "LANDSCAPER",
  "LAWYER",
  "LIBRARIAN",
  "LINEMAN",
  "LUMBER",
  "MACHINIST",
  "MAIL CARRIER",
  "MAINTENANCE",
  "MANAGER",
  "MANICURIST",
  "MARKETER",
  "MASON",
  "MEAT CUTTER",
  "MECHANIC",
  "MERCHANT",
  "METALLURGIST",
  "MILITARY",
  "MILLWRIGHT",
  "MINER",
  "MINISTER",
  "MORTICIAN",
  "MUSICIAN",
  "NAVIGATOR",
  "NURSE",
  "NURSES AID",
  "OFFICER",
  "OFFICE WORKER",
  "OPTOMETRIST",
  "OWNER",
  "PACKER",
  "PAINTER",
  "PARALEGAL",
  "PAYROLL CLERK",
  "PERSONNEL",
  "PHARMACIST",
  "PHOTOGRAPHER",
  "PHYSICIAN",
  "PHYSICIST",
  "PILOT",
  "PIPEFITTER",
  "PLANNER",
  "PLASTERER",
  "PLUMBER",
  "POLICEMAN",
  "POLISHER",
  "PRESIDENT",
  "PRESSER",
  "PRINCIPAL",
  "PRINTER",
  "PROCESSOR",
  "PRODUCER",
  "PROFESSOR",
  "PROGRAMMER",
  "PROPRIETOR",
  "PSYCHOLOGIST",
  "RAILROAD WORKER",
  "REALTOR",
  "RECEIVER",
  "RECEPTIONIST",
  "REGISTRAR",
  "REPAIRMAN",
  "REPORTER",
  "ROOFER",
  "SALES",
  "SCIENTIST",
  "SEAMSTRESS",
  "SECRETARY",
  "SECURITY",
  "SELF EMPLOYED",
  "SERVER",
  "SERVICEMAN",
  "SHIPPER",
  "SHOEMAKER",
  "SOCIAL WORKER",
  "SOFTWARE DEVELOPER",
  "STUDENT",
  "SUPERVISOR",
  "SURGEON",
  "SURVEYOR",
  "TAILOR",
  "TEACHER",
  "TECHNICIAN",
  "TECHNOLOGIST",
  "TELEMARKETER",
  "THERAPIST",
  "TRAINER",
  "TRUCKER",
  "TYPIST",
  "UNDERWRITER",
  "UNEMPLOYED",
  "UPHOLSTERER",
  "US POSTAL WORKER",
  "UTILITYMAN",
  "VETERINARIAN",
  "VICE PRESIDENT",
  "WAITER",
  "WAITRESS",
  "WAREHOUSE WORKER",
  "WEB DEVELOPER",
  "WELDER",
  "WINDOW CLEANER",
  "WORKER",
  "WRITER",
  "YOUTH PROGRAM DEVELOPER"
]);
exports.OCCUPATIONS = _OCCUPATIONS;

exports.getOccupationStateFromAppData = (occupation) => {
  return occupation.length===0?'':_OCCUPATIONS_COMMON.indexOf(occupation)<0?'OTHER':occupation;
};

exports.getCommonOccupations = () => {
  let occupations = _OCCUPATIONS_COMMON.slice(); // [..._OCCUPATIONS_COMMON]; AWD this file does not like the spread operator
  occupations.sort();
  occupations.push('other');
  return occupations.map((item)=>{
    return item.toLowerCase()
      .split(' ')
      .map((word)=>(word[0].toUpperCase()+word.substring(1)))
      .join(' ');
  });
};

exports.getOtherOccupations = () => {
  let commonOccupations = _OCCUPATIONS_COMMON.slice(); // [..._OCCUPATIONS_COMMON]; AWD this file does not like the spread operator
  let occupations = _OCCUPATIONS.slice() // [..._OCCUPATIONS] AWD this file does not like the spread operator
      .filter((item)=>{
    return commonOccupations.indexOf(item)<0;
  });
  occupations.sort();
  return occupations.map((item)=>{
    return item.toLowerCase()
      .split(' ')
      .map((word)=>(word[0].toUpperCase()+word.substring(1)))
      .join(' ');
  });
};


/*

<option value="0">$0</option>
                    <option value="1 - 833">$1 - $10,000</option>
                    <option value="833 - 1,667">$10,000 - $20,000</option>
                    <option value="1,667 - 2,500">$20,000 - $30,000</option>
                    <option value="2,500 - 3,333">$30,000 - $40,000</option>
                    <option value="3,333 - 4,167">$40,000 - $50,000</option>
                    <option value="4,167 - 5,000">$50,000 - $60,000</option>
                    <option value="5,000 - 5,833">$60,000 - $70,000</option>
                    <option value="5,833 - 6,667">$70,000 - $80,000</option>
                    <option value="6,667 - 7,500">$80,000 - $90,000</option>
                    <option value="7,500 - 8,333">$90,000 - $100,000</option>
                    <option value="8,333 - 9,167">$100,000 - $110,000</option>
                    <option value="9,167 - 10,000">$110,000 - $120,000</option>
                    <option value="10,000 - 10,833">$120,000 - $130,000</option>
                    <option value="10,833 - 11,667">$130,000 - $140,000</option>
                    <option value="11,667 - 12,500">$140,000 - $150,000</option>
                    <option value="12,500+">$150,000+</option>

 */

const _INCOME_OPTIONS = Object.freeze(
    [
      {
        key: 0,
        rangeMin: 0,
        rangeMax: 0,
        isRange: false

      },
      {
        key: 1,
        rangeMin: 1,
        rangeMax: 10000,
        isRange: true
      },
      {
        key: 2,
        rangeMin: 10000,
        rangeMax: 20000,
        isRange: true
      },
      {
        key: 3,
        rangeMin: 20000,
        rangeMax: 30000,
        isRange: true
      },
      {
        key: 4,
        rangeMin: 30000,
        rangeMax: 40000,
        isRange: true
      },
      {
        key: 5,
        rangeMin: 40000,
        rangeMax: 50000,
        isRange: true
      },
      {
        key: 6,
        rangeMin: 50000,
        rangeMax: 60000,
        isRange: true
      },
      {
        key: 7,
        rangeMin: 60000,
        rangeMax: 70000,
        isRange: true
      },
      {
        key: 8,
        rangeMin: 70000,
        rangeMax: 80000,
        isRange: true
      },
      {
        key: 9,
        rangeMin: 80000,
        rangeMax: 90000,
        isRange: true
      },
      {
        key: 10,
        rangeMin: 90000,
        rangeMax: 100000,
        isRange: true
      },
      {
        key: 11,
        rangeMin: 100000,
        rangeMax: 110000,
        isRange: true
      },
      {
        key: 12,
        rangeMin: 110000,
        rangeMax: 120000,
        isRange: true
      },
      {
        key: 13,
        rangeMin: 120000,
        rangeMax: 130000,
        isRange: true
      },
      {
        key: 14,
        rangeMin: 130000,
        rangeMax: 140000,
        isRange: true
      },
      {
        key: 15,
        rangeMin: 140000,
        rangeMax: 150000,
        isRange: true
      },
      {
        key: 16,
        rangeMin: 150000,
        rangeMax: 150000,
        isRange: false
      }
    ]
);
exports.INCOME_OPTIONS = _INCOME_OPTIONS;

const _EXPENSES_OPTIONS = Object.freeze(
    [
      {
        key: 0,
        rangeMin: 0,
        rangeMax: 0,
        isRange: false

      },
      {
        key: 1,
        rangeMin: 1,
        rangeMax: 1000,
        isRange: true
      },
      {
        key: 2,
        rangeMin: 1000,
        rangeMax: 2000,
        isRange: true
      },
      {
        key: 3,
        rangeMin: 2000,
        rangeMax: 3000,
        isRange: true
      },
      {
        key: 4,
        rangeMin: 3000,
        rangeMax: 4000,
        isRange: true
      },
      {
        key: 5,
        rangeMin: 4000,
        rangeMax: 5000,
        isRange: true
      },
      {
        key: 6,
        rangeMin: 5000,
        rangeMax: 6000,
        isRange: true
      },
      {
        key: 7,
        rangeMin: 6000,
        rangeMax: 7000,
        isRange: true
      },
      {
        key: 8,
        rangeMin: 7000,
        rangeMax: 8000,
        isRange: true
      },
      {
        key: 9,
        rangeMin: 8000,
        rangeMax: 9000,
        isRange: true
      },
      {
        key: 10,
        rangeMin: 9000,
        rangeMax: 10000,
        isRange: true
      },
      {
        key: 11,
        rangeMin: 10000,
        rangeMax: 11000,
        isRange: true
      },
      {
        key: 12,
        rangeMin: 11000,
        rangeMax: 12000,
        isRange: true
      },
      {
        key: 13,
        rangeMin: 12000,
        rangeMax: 13000,
        isRange: true
      },
      {
        key: 14,
        rangeMin: 13000,
        rangeMax: 14000,
        isRange: true
      },
      {
        key: 15,
        rangeMin: 14000,
        rangeMax: 15000,
        isRange: true
      },
      {
        key: 16,
        rangeMin: 15000,
        rangeMax: 15000,
        isRange: false
      }
    ]
);
exports.EXPENSES_OPTIONS = _EXPENSES_OPTIONS;

// 2021.06.30.ADivelbiss - Moved Available states here
const _AVAILABLE_STATES = Object.freeze([
  {abbreviation: "AL"},
  {abbreviation: "AK"},
  {abbreviation: "AZ"},
  {abbreviation: "AR"},
  //{abbreviation: "CA"},
  {abbreviation: "CO"},
  {abbreviation: "CT"},
  {abbreviation: "DE"},
  {abbreviation: "FL"},
  {abbreviation: "GA"},
  {abbreviation: "HI"},
  {abbreviation: "ID"},
  {abbreviation: "IL"},
  {abbreviation: "IN"},
  {abbreviation: "IA"},
  {abbreviation: "KS"},
  {abbreviation: "KY"},
  {abbreviation: "LA"},
  {abbreviation: "MD"},
  {abbreviation: "MA"},
  //{abbreviation: "ME"},
  {abbreviation: "MI"},
  {abbreviation: "MN"},
  {abbreviation: "MS"},
  {abbreviation: "MO"},
  {abbreviation: "MT"},
  {abbreviation: "NE"},
  {abbreviation: "NV"},
  {abbreviation: "NH"},
  {abbreviation: "NJ"},
  {abbreviation: "NM"},
  {abbreviation: "NC"},
  {abbreviation: "ND"},
  //{abbreviation: "NY"},
  {abbreviation: "OH"},
  {abbreviation: "OK"},
  {abbreviation: "OR"},
  {abbreviation: "PA"},
  {abbreviation: "RI"},
  {abbreviation: "SC"},
  {abbreviation: "SD"},
  {abbreviation: "TN"},
  {abbreviation: "TX"},
  {abbreviation: "UT"},
  {abbreviation: "VT"},
  {abbreviation: "VA"},
  {abbreviation: "WA"},
  {abbreviation: "WV"},
  {abbreviation: "WI"},
  {abbreviation: "WY"}
]);
exports.AVAILABLE_STATES = _AVAILABLE_STATES;

// App Sections
const VIEW_SECTIONS = Object.freeze([
  {
    name: 'premium',
    label: 'Select Premium Amount',
    pages: [PAGES.pageAppPremium]
  },
  {
    name: 'questions',
    label: 'Answer a Few Questions',
    pages: [PAGES.pageAppFinances,PAGES.pageAppGoals,PAGES.pageAppFinancesFL, PAGES.pageAppNeedsFL, PAGES.pageAppGoalsFL]
  },
  {
    name: 'identity',
    label: 'Verify Your Identity',
    pages: [PAGES.pageAppIdOwnerAnnuitant,PAGES.pageAppIdOwnerAnnuitantSummary]
  },
  {
    name: 'beneficiaries',
    label: 'Add Your Loved Ones',
    pages: [PAGES.pageAppBenes]
  },
  {
    name: 'payment',
    label: 'Select Payment',
    pages: [PAGES.pageAppPayments,PAGES.pageAppMailCheckInfo,PAGES.pageAppConfirmEFT]
  },
  {
    name: 'verify',
    label: 'Final Review',
    pages: [PAGES.pageAppFinalize]
  }
]);
exports.VIEW_SECTIONS = VIEW_SECTIONS;

const sectionNameForPage = (page) => {
  return VIEW_SECTIONS.reduce((name,section)=>{
    return section.pages.includes(page) ? section.name : name;
  },'');
};
exports.sectionNameForPage = sectionNameForPage;


const _APP_COMPLETION_STATUS  = Object.freeze({
  notStarted: "notStarted", // Should never be sent to backend
  inProgress: "inProgress", // Should never be sent to backend
  finishedInvalid: "finishedInvalid", // Should never be sent to backend
  finishedIncomplete: "finishedIncomplete", // Should never be sent to backend
  finishedScheduleCall: "finishedScheduleCall", // Path B response
  finishedAgentFollowUp: "finishedAgentFollowUp", // Path C response
  finishedComplete: "finishedComplete" // Path A response
});
exports.APP_COMPLETION_STATUS = _APP_COMPLETION_STATUS;

const _CALL_SCHEDULE_CUSTOMER = Object.freeze({
  consent: "Q1_CONSENT",
  state: "state",
  dob: "dob",
  age: "age",
  token: "token",
  requestType: "requestType",
  channelSource: "channelSource",
  productName: "productName",
  term: "term",
  amount: "amount",
  quote: "quote",
  rate: "rate",
  creation: "creation",
  firstName : "OWNER_FIRST_NAME",
  lastName : "OWNER_LAST_NAME",
  email : "SECTION_2_EMAIL_ADDRESS",
  phone : "SECTION_2_HOME_TELEPHONE",
  addressZip : "SECTION_2_OWNER_ZIP_CODE",
  insuredLastName: "insuredLastName",
  insuredFirstName: "insuredFirstName",
  insuredPhone: "insuredPhone",
  flowType: "flowType",
  appointment: "appointment"
});
exports.CALL_SCHEDULE_CUSTOMER = _CALL_SCHEDULE_CUSTOMER;

const _EVENTS = Object.freeze({
  sessionCleared: 'sessionCleared'
})
exports.EVENTS = _EVENTS;


const _SESSION_TIMEOUT_MINUTES = 15;
exports.SESSION_TIMEOUT_DURATION = _SESSION_TIMEOUT_MINUTES * 60 * 1000;
exports.SESSION_TIMEOUT_WARNING_DURATION = (_SESSION_TIMEOUT_MINUTES - 1) * 60 * 1000;
const _MOBILE_SESSION_TIMEOUT_MINUTES = 24 * 60;
exports.MOBILE_SESSION_TIMEOUT_DURATION = _MOBILE_SESSION_TIMEOUT_MINUTES * 60 * 1000;
exports.MOBILE_SESSION_TIMEOUT_WARNING_DURATION = (_MOBILE_SESSION_TIMEOUT_MINUTES - 1) * 60 * 1000;
exports.SESSION_LAST_ACTIVITY_KEY = 'SESSION_LAST_ACTIVITY_KEY';
exports.currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

exports.NASSAU_CHART_COLOR = '#426DA0F5';
exports.OTHER_CHART_COLOR = 'gray';
exports.TREASURY_HIGH_CHART_COLOR = '#568ac7f5';
exports.TREASURY_LOW_CHART_COLOR = '#426DA0F5';

exports.MIN_AGE = 0;
exports.MAX_AGE = 120;

